import { DesktopRow, FooterContainer, Link, MobileRow } from "./Footer.styles";
import { useNavigate } from "react-router-dom";

const SUPPORT_EMAIL = "support@fapify.com";
// const TELEGRAM_URL = "https://t.me/fapifyvip";

const TOP_ROW = [
  {
    label: "Support",
    href: `mailto:${SUPPORT_EMAIL}`,
    title: "Contact Support via Email",
  },
  // { label: "Submit a Request", href: "/submit-a-request" },
];

const BOTTOM_ROW = [
  // {
  //   label: "Telegram",
  //   href: TELEGRAM_URL,
  //   external: true,
  //   title: "Giveaways and Announcements",
  // },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Use", href: "/terms-and-conditions" },
];

const FOOTER_LINKS = [...TOP_ROW, ...BOTTOM_ROW];

const Footer = ({ isFeedView }) => {
  const navigate = useNavigate();

  const handleClick = (event, link) => {
    if (!link.href?.startsWith("/")) {
      return;
    }

    event.preventDefault();
    navigate(link.href);
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  };

  const renderLinks = (links) =>
    links.map((link) => (
      <Link
        key={link.label}
        href={link.href}
        onClick={(event) => handleClick(event, link)}
        title={link.title}
        target={link.external ? "_blank" : undefined}
        rel={link.external ? "noreferrer" : undefined}
      >
        {link.label}
      </Link>
    ));

  return (
    <FooterContainer $isFeedView={isFeedView}>
      <MobileRow>{renderLinks(TOP_ROW)}</MobileRow>
      <MobileRow>{renderLinks(BOTTOM_ROW)}</MobileRow>
      <DesktopRow>{renderLinks(FOOTER_LINKS)}</DesktopRow>
    </FooterContainer>
  );
};

export default Footer;
